// extracted by mini-css-extract-plugin
export var deliveryRow = "_r8-a";
export var fixedHeight = "_r8-4";
export var freightLogo = "_r8-9";
export var fullWidth = "_r8-3";
export var priceColumn = "_r8-5";
export var radioSelected = "_r8-7";
export var radioUnselected = "_r8-6";
export var selectedOption = "_r8-2";
export var selectedOptionContainer = "_r8-1";
export var selection = "_r8-0";
export var tallSkeletonText = "_r8-8";